import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useNavigateToVideos = () => {
  const navigate = useNavigate();

  return useCallback(async () => {
    await navigate(routes.video.index);
  }, [navigate]);
};
